import type { User } from '@src/manageUsers/domain/User';

export class UserList {
  constructor(public readonly users: User[]) {}

  sort() {
    const activeUser = this.users.filter((user) => !user.isInactive);
    const inactiveUser = this.users.filter((user) => user.isInactive);

    return new UserList(
      activeUser.sort(this.byName).concat(inactiveUser.sort(this.byName)),
    );
  }

  private byName(user1: User, user2: User) {
    return user1.name.localeCompare(user2.name);
  }
}
